import Clipboard from 'clipboard';
import { Notification } from '../components/notifications';

new Clipboard('.js-clipboard');

const copyButtons = Array.from(document.querySelectorAll('.js-clipboard'));
copyButtons.forEach((button) => {
    button.addEventListener('click', () => {
        const notice = new Notification({
            innerHtml: `Code copied to clipboard`
        });
        notice.mount();
    });
});
